import { Grid } from '@material-ui/core';
import { TransactionReject } from 'components/ui/TransactionReject';
import { useQueryParams } from 'hooks/useQueryParams';
import React, { memo } from 'react';

export const Reject = memo(() => {
  const params = useQueryParams();
  const transactionId = params.get('transactionId');

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="baseline"
    >
      <Grid item sm={12} md={8}>
        <TransactionReject transactionId={transactionId!} />
      </Grid>
    </Grid>
  );
});
